(function () {
    'use strict';

    angular
        .module('externalPartyEditModule')
        .controller('ODDCampaignObservationListController', Controller);

    Controller.$inject = ['$scope', '$state', '$stateParams', 'historyCtxtService', 'businessUnit', 'campaign', 'observations'];

    function Controller($scope, $state, $stateParams, historyCtxtService, businessUnit, campaign, observations) {
        $scope.businessUnit = businessUnit;
        $scope.campaign = campaign;
        $scope.observations = observations;

        $scope.goToCampaign = function (campaign) {
            $state.go('odd.externalPartyEdit.campaign', {
                    ODDExternalPartyID: campaign.ODDExternalPartyID,
                    ODDCampaignID: campaign.ODDCampaignID
                })
        };

        // Edit Observation
        $scope.editObservation = function (item) {
            historyCtxtService.goToState('observation.edit',
                { ObservationID: item.ObservationID },
                'odd.externalPartyEdit.campaign.editObservationList',
                $scope.observations
            );
        };

        // Add Observation
        $scope.addObservation = function () {
            $state.go('observation.addForODDCampaign', {
                BusinessUnitCode: $stateParams.BusinessUnitCode,
                ODDCampaignID: $scope.campaign.ODDCampaignID
            });
        }
    }
})();